// extracted by mini-css-extract-plugin
export default {"l":"ef4ada7c2a"};